var map = {
	"./": "./src/lang/index.js",
	"./en": "./src/lang/en.js",
	"./en.js": "./src/lang/en.js",
	"./index": "./src/lang/index.js",
	"./index.js": "./src/lang/index.js",
	"./zh": "./src/lang/zh.js",
	"./zh.js": "./src/lang/zh.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/lang sync recursive ^\\.\\/.*$";